import { cache } from '@/container/apollo-client/cache';
import { QUERY_GET_NOTIFICATIONS } from '@/graphql/cursor.graphql';
import { QUERY_GET_NOTIFICATION_COUNT } from '@/graphql/query.graphql';
import {
  GetAllNotificationV2Query,
  NotificationV2,
  ObtainNotificationCountQuery,
  useNotificationSubscriptionSubscription,
} from '@/types/generated/graphql';

export function useNotificationSubscriptions() {
  useNotificationSubscriptionSubscription({
    onData: ({ data }) => {
      const newCount = data?.data?.notificationSubscription?.counter ?? 0;
      const newNotification = data?.data?.notificationSubscription?.notification as NotificationV2;
      appendNewNotificationToList(newNotification);
      increaseNotificationCount(newCount);
    },
  });

  function appendNewNotificationToList(newNotification: NotificationV2) {
    cache.updateQuery<GetAllNotificationV2Query>({ query: QUERY_GET_NOTIFICATIONS }, (data) => {
      if (data) {
        return {
          ...data,
          getAllNotificationV2: {
            ...data?.getAllNotificationV2,
            data: [newNotification, ...(data?.getAllNotificationV2?.data || [])],
          },
        };
      }
      return data;
    });
  }

  function increaseNotificationCount(newCount: number) {
    cache.updateQuery<ObtainNotificationCountQuery>({ query: QUERY_GET_NOTIFICATION_COUNT }, (data) => {
      return {
        ...data,
        obtainNotificationCount: {
          ...data?.obtainNotificationCount,
          data: {
            ...data?.obtainNotificationCount?.data,
            count: newCount,
          },
        },
      };
    });
  }
}
